
export const fr = {
  auth: {
    login: "Se connecter",
    startFreeTrial: "Démarrer l'essai gratuit",
    register: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    errorDescription: "Une erreur est survenue",
    errorTitle: "Erreur",
    successTitle: "Succès",
    successDescription: "Opération réussie",
    continueWithGoogle: "Continuer avec Google",
    createAccount: "Créer un compte",
    trialDescription: "Essai gratuit de 14 jours",
    emailPlaceholder: "votre@email.com",
    creating: "Création en cours...",
    create: "Créer",
    errorMessage: "Une erreur s'est produite"
  },
  navigation: {
    pricing: "Tarifs",
    about: "À propos",
    contact: "Contact",
    themes: "Thèmes",
    resources: "Ressources",
    home: "Accueil",
    dashboard: "Tableau de bord",
    products: "Produits",
    orders: "Commandes",
    customers: "Clients",
    settings: "Paramètres"
  },
  footer: {
    acceptedPayments: "Moyens de paiement acceptés",
    allRightsReserved: "Tous droits réservés",
    quickLinks: "Liens rapides",
    legalNotice: "Mentions légales",
    accessibility: "Accessibilité",
    termsOfUse: "Conditions d'utilisation",
    support: "Support",
    followUs: "Suivez-nous",
    socialMedia: "Retrouvez-nous sur les réseaux sociaux",
    newsletter: "Newsletter",
    subscribeNewsletter: "Inscrivez-vous à notre newsletter",
    emailPlaceholder: "Votre email",
    subscribe: "S'inscrire",
    changeLanguage: "Changer de langue"
  },
  pricing: {
    title: "Plans et tarifs",
    subtitle: "Choisissez le plan qui vous convient",
    startTrial: "Commencer l'essai gratuit",
    mostPopular: "Le plus populaire",
    freeTrial: "14 jours d'essai gratuit",
    perMonth: "/mois",
    basic: {
      name: "Basique",
      price: "11",
      description: "Pour démarrer",
      features: [
        "1 boutique",
        "100 produits",
        "Support par email"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Pour les professionnels",
      features: [
        "3 boutiques",
        "1000 produits",
        "Support prioritaire",
        "Analyses avancées"
      ]
    },
    enterprise: {
      name: "Entreprise",
      price: "97",
      description: "Pour les grandes entreprises",
      features: [
        "Boutiques illimitées",
        "Produits illimités",
        "Support dédié",
        "API personnalisée"
      ]
    }
  },
  profile: {
    title: "Mon Profil",
    fullName: "Nom complet",
    phoneNumber: "Numéro de téléphone",
    update: "Mettre à jour",
    updating: "Mise à jour...",
    success: "Profil mis à jour avec succès",
    error: "Erreur lors de la mise à jour du profil"
  },
  common: {
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    search: "Rechercher",
    filter: "Filtrer",
    sort: "Trier",
    actions: "Actions",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    close: "Fermer"
  }
};
